import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export function credentialsInterceptor(
  httpRequest: HttpRequest<unknown>,
  httpHandler: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {

  if(httpRequest.url.startsWith("https://storage.googleapis.com")) {
    return httpHandler(httpRequest);
  } else {
    return httpHandler(httpRequest.clone({ withCredentials: true }));
  }
}
